import i18n from '../../language/index'
import {
  create_title
} from '@/base/titleData'
import pageData from '@/base/pageData'
import {
  basic_download_new_style,
  getCommonStyle
} from '@/base/widgets_data_compatible';

export default {
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_infor: {
    marginTop: '0',
    marginRight: '0',
    marginBottom: '0',
    marginLeft: '0'
  },
  mb_infor: {
    marginTop: '0',
    marginRight: '0',
    marginBottom: '0',
    marginLeft: '0'
  },
  pc_widgets_infor: {
    font: {
      radio_val: 'default',
      default: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal'
      },
      custom: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal'
      }
    },

    header_font: {
      radio_val: 'default',
      default: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal'
      },
      custom: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal'
      }
    },

    background: {
      radio_val: 'default',
      default: {
        color: 'rgba(255,255,255,0)', // 背景设置-颜色
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(255,255,255,1)', // 背景设置-选中颜色
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(255, 255, 255,1)', // 背景设置-选中颜色
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
    borderRadius: {
      ...getCommonStyle().borderRadius
    },
    title: create_title(i18n.t('router_default_81')),
    page: pageData,
  },
  mb_widgets_infor: {
    title: create_title(i18n.t('router_default_81')),
  },
  listArr: {
    moduleStyle: 0,
    fileList: [],
    ...basic_download_new_style()
  }
}



// WEBPACK FOOTER //
// ./src/widgets/basic_download_display/style.js